export enum ActivitiesTab {
  All = 'all-activities-tab',
  My = 'my-activities-tab',
}
